import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// sidebar palette
import { SIDEBAR_FONT } from '../../../layouts/dashboard/navbar/sidebarTokens';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

// Group labels are eyebrows: small, tracked, quiet. They only appear when
// there is more than one group — a label over the only list there is tells
// the reader nothing, and "MANAGEMENT" over a linguist's projects told them
// less than that.
export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  paddingLeft: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  lineHeight: 1.4,
  fontFamily: SIDEBAR_FONT,
  fontSize: '0.66rem',
  fontWeight: 700,
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: 'var(--sb-text-muted)',
  backgroundColor: 'transparent',
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter
  })
}));

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array
};

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}) {
  const { translate } = useLocales();
  const showGroupLabels = navConfig.length > 1;

  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List
          key={group.subheader}
          disablePadding
          sx={{ px: 2, ...(isCollapse && { px: 1.5 }) }}
        >
          {showGroupLabels && (
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0
                })
              }}
            >
              {translate(group.subheader)}
            </ListSubheaderStyle>
          )}

          {group.items.map((list, i) => {
            return (
              <NavListRoot
                key={list.title + list.path + i}
                list={list}
                isCollapse={isCollapse}
              />
            );
          })}
        </List>
      ))}
    </Box>
  );
}
